import './styles.css'
function MessageTitle(props){
    return(
        <>
            <div style={props.style} className="box">
                <label className='box-text' >{props.message}</label>
            </div>
        </>
    )

}
export default MessageTitle